import React, { useEffect } from "react";
import Background_Member2 from "../../assets/images/inner-banner.jpg";
import { Link } from "react-router-dom";

const TermsConditions = () => {
  document.title =
    "Terms & Conditions | Gujarat State Allied and Healthcare Council";
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="wrappermain">
        <div
          className="banner-image wrappermain"
          style={{
            backgroundImage: "url(" + Background_Member2 + ")",
            backgroundSize: "fill",
            backgroundPosition: "right",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            padding: "25px 0",
          }}
        >
          <div className="banner-inner-breadcrumb">
            <div className="container">
              <nav aria-label="breadcrumb">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={"/"}>Home</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Terms & Conditions
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
        <div className="terms-conditions-wrapper p-t-60 p-b-60">
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <h2 className="section-title text-center">
                  Terms & Conditions
                </h2>
                <div className="terms-conditions-desc py-2">
                  <h3>Disclaimer</h3>
                  <p>
                    This website is designed, developed and maintained by{" "}
                    <strong>
                      “Gujarat State Allied and Healthcare Council”.
                    </strong>
                  </p>
                  <p>
                    Though all efforts have been made to ensure the accuracy and
                    currency of the content on this website, the same should not
                    be construed as a statement of law or used for any legal
                    purposes. In case of any ambiguity or doubts, users are
                    advised to verify/check with the Department, and to obtain
                    appropriate professional advice.
                  </p>
                  <p>
                    Under no circumstances will this Department be liable for
                    any expense, loss or damage including, without limitation,
                    indirect or consequential loss or damage, or any expense,
                    loss or damage whatsoever arising from use, or loss of use,
                    of data, arising out of or in connection with the use of
                    this website.
                  </p>
                  <p>
                    These terms and conditions shall be governed by and
                    construed in accordance with the Indian Laws. Any dispute
                    arising under these terms and conditions shall be subject to
                    the jurisdiction of the courts of India.
                  </p>
                  <p>
                    The information posted on this website could include
                    hypertext links or pointers to information created and
                    maintained by non- Government/private organisation. <strong>“Gujarat
                    State Allied and Healthcare Council”</strong> is providing these
                    links and pointers solely for your information and
                    convenience. When you select a link to an outside website,
                    you are leaving the <strong>“Gujarat State Allied and Healthcare
                    Council”</strong> website and are subject to the privacy and security
                    policies of the owners/sponsors of the outside website.
                  </p>
                    <br />
                  <h3>Terms &amp; Conditions</h3>
                  <p>
                    Though all efforts have been made to ensure the accuracy and
                    currency of the content on this website, the same should not
                    be construed as a statement of law or used for any legal
                    purposes. In case of any ambiguity or doubts, users are
                    advised to verify/check with <strong>Gujarat State Allied and
                    Healthcare Council</strong> and/or other source(s), and to obtain
                    appropriate professional advice.
                  </p>
                  <p>
                    Under no circumstances will <strong>Gujarat State Allied and
                    Healthcare Council</strong> be liable for any expense, loss or damage
                    including, without limitation, indirect or consequential
                    loss or damage, or any expense, loss or damage whatsoever
                    arising from use, or loss of use, of data, arising out of or
                    in connection with the use of this website.
                  </p>
                  <p>
                    These terms and conditions shall be governed by and
                    construed in accordance with the Indian Laws. Any dispute
                    arising under these terms and conditions shall be subject to
                    the exclusive jurisdiction of the courts of India.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsConditions;
